import React from "react";
import { Link } from "ui/link";
import { MobileDrawer } from "./mobile-drawer";
import { type NavTabProps } from "./data";

export function MobileNavItem({ ...props }: NavTabProps & { onToggleNav: () => void }) {
  const { label, columns: children, href } = props;

  if (href) {
    return (
      <Link href={href} variant="navMobile">
        {label}
      </Link>
    );
  }

  if (children) {
    return <MobileDrawer {...props} />;
  }

  return null;
}
